import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

export default function Centered(props: PropsWithChildren) {
    const { children } = props;
    return (
        <div css={css({ display: "flex", flexDirection: "column", alignItems: "center" })}>
            {children}
        </div>
    );
}
